<template>
    <div id="data-list-thumb-view" class="data-list-container">
        <vs-table
                ref="table"
                :max-items="20"
                pagination
                search
                v-if="coupons !== null"
                :data="coupons"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <!-- ADD NEW -->
                    <div
                            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                        <span
                                class="ml-2 text-base text-primary"
                                @click.stop="openCreatePopup"
                        >Coupon toevoegen</span>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="code">Code</vs-th>
                <vs-th sort-key="usage">Keren gebruikt</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                        @click.native="openPopup(tr)"
                >
                    <vs-td>
                        <p class="coupon-code">{{tr.code}}</p>
                    </vs-td>

                    <vs-td>
                        <p class="deliverer-phone_number">{{ tr.used }}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <ht-coupon-popup></ht-coupon-popup>
    </div>
</template>
<script>
    import CouponPopup from "./CouponPopup";
    import HtCouponPopup from "./CouponPopup";
    export default {
        components: {
            HtCouponPopup,
            CouponPopup
        },
        data() {
            return {
                coupons: null,
                selected: [],
            };
        },
        watch: {
            $route(to, from) {
                // react to route changes...
                if (to.params.slug !== null) {
                    this.getCoupons();
                }
            },
        },

        computed: {
            staffRoute() {
                if (this.$route.meta.staff) {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                } else {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                    return false;
                }
            },
        },
        methods: {
            openPopup(contact) {
                this.$events.fire("open-contact-popup", contact);
            },
            openCreatePopup() {
                this.$events.fire('create-coupon-modal');
            },
            getCoupons() {
                let url = this.staffRoute
                    ? "https://staffapi.hebtrek.nl/v1/company/" +
                    this.$route.params.slug +
                    "/coupons"
                    : "https://companyapi.hebtrek.nl/v1/company/" +
                    this.$route.params.slug +
                    "/coupons";
                let token = this.staffRoute
                    ? JSON.parse(localStorage.getItem("stafftoken"))
                    : JSON.parse(localStorage.getItem("companytoken"));
                this.$http
                    .get(url, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        this.coupons = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
        },
        mounted() {
            this.getCoupons();
            this.$events.listen("refresh-coupons", () => {
                this.getCoupons();
            });
        },
    };
</script>
